import { render, staticRenderFns } from "./Rolunk.html?vue&type=template&id=ea214840&"
import script from "./Rolunk.js?vue&type=script&lang=js&"
export * from "./Rolunk.js?vue&type=script&lang=js&"
import style0 from "./Rolunk.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports